import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/mypage/exit.svg")